import {
	Button,
	DropMenu,
	DropMenuItem,
	DropMenuSection,
	LogOutIcon,
	MessageCircleQuestionIcon,
	Tabs,
} from '@sailadv/hdata-ui';
import { useTranslation } from 'react-i18next';

import { useManagedLogout, useUserTheme } from '@/entities/user';
import { useChangeTheme } from '@/features/change-theme';
import { AppTheme } from '@/shared/constants/app-theme.constant';
import { SUPPORT_LINK } from '@/shared/constants/support-link.constant';
import { USER_MENU_THEME_OPTIONS } from '@/widgets/header/model/constants/user-menu-theme-options.constant';

export const UserMenuFooter = () => {
	const { t } = useTranslation('common');
	const theme = useUserTheme();
	const changeTheme = useChangeTheme();
	const [managedLogout] = useManagedLogout();

	const themeItems = USER_MENU_THEME_OPTIONS.map(({ value, label, Icon }) => ({
		value,
		label: t(label),
		icon: <Icon />,
	}));

	const handleThemeChange = (value: string) => {
		changeTheme(value as AppTheme);
	};

	const handleLogout = () => {
		managedLogout();
	};

	return (
		<div className="flex flex-col gap-2">
			<div className="flex items-center justify-between gap-3 border-t border-border pt-2">
				<span className="px-3 py-2 text-xs font-medium uppercase text-muted-foreground">
					{t('header.user-menu.section.appearance')}
				</span>
				<Tabs variant="segmented" size="sm" items={themeItems} value={theme} onChange={handleThemeChange} />
			</div>
			{/* A standalone menu, so Support looks exactly like the items above */}
			<DropMenu
				aria-label={t('header.user-menu.section.help')}
				className="w-full! rounded-none! border-x-0! border-b-0! px-0! pb-0! shadow-none!"
			>
				<DropMenuSection label={t('header.user-menu.section.help')}>
					<DropMenuItem
						id="support"
						href={SUPPORT_LINK}
						target="_blank"
						rel="noopener noreferrer"
						leading={<MessageCircleQuestionIcon />}
					>
						{t('header.user-menu.support.label')}
					</DropMenuItem>
				</DropMenuSection>
			</DropMenu>
			<Button variant="secondary" size="md" leadingIcon={<LogOutIcon />} onClick={handleLogout}>
				{t('header.user-menu.logout.label')}
			</Button>
		</div>
	);
};
